export default __webpack_public_path__ + "static/media/attendance.567470de.svg";